<template>
	<div
		class="d-flex align-items-center justify-content-center justify-content-sm-between flex-wrap"
	>
		<div class="small d-flex align-items-center justify-content-center">
			Show
			<b-form-select
				v-model="currentPerPage"
				@change="$emit('paginate', paginationData)"
				:options="pageSizeOptions"
				size="sm"
				class="drv-field__select px-1 mx-2"
			></b-form-select>
			entries
		</div>

		<b-pagination
			v-if="totalItems < totalPages"
			v-model="currentPage"
			@input="$emit('paginate', paginationData)"
			:total-rows="totalPages"
			:per-page="pageSize"
			ellipsis-class="d-none"
			class="drv-pagination mb-0"
			hide-ellipsis
		></b-pagination>
	</div>
</template>

<script>
import { DEFAULT_PER_PAGE_DROPDOWN } from "./../utils/constants";

export default {
	name: "drv-pagination",
	props: {
		page: Number,
		pageSize: Number,
		totalItems: Number,
		totalPages: Number,
	},
	data() {
		return {
			pageSizeOptions: DEFAULT_PER_PAGE_DROPDOWN,
			currentPage: 1,
			currentPerPage: 10,
		};
	},
	computed: {
		paginationData() {
			return {
				page: this.currentPage,
				pageSize: this.currentPerPage,
			};
		},
	},
	mounted() {
		if (this.page) this.currentPage = this.page;
		if (this.pageSize) this.currentPerPage = this.pageSize;
	},
};
</script>
